var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevron(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 12,
    viewBox: "0 0 7 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.89618 6.30461L1.32403 11.8948C1.28285 11.9345 1.23356 11.9642 1.17978 11.9817C1.12599 11.9993 1.06906 12.0043 1.01317 11.9963C0.958387 12.0032 0.902803 11.9977 0.850312 11.9801C0.797821 11.9626 0.749694 11.9335 0.709305 11.8948L0.103906 11.2847C0.00287681 11.2847 0.00287681 11.1832 0.00287681 11.0817C-0.00388933 11.0263 0.00169263 10.9701 0.0191986 10.9174C0.0367046 10.8646 0.0656741 10.8166 0.103906 10.7771L4.8686 6L0.103906 1.32529C0.0655632 1.28566 0.0365286 1.23755 0.0190191 1.18462C0.00150969 1.13168 -0.00401161 1.07534 0.00287681 1.01988C-0.00388933 0.964542 0.00169263 0.90835 0.0191986 0.855568C0.0367046 0.802785 0.0656741 0.754803 0.103906 0.715264L0.712413 0.105241C0.752448 0.0669842 0.80006 0.0380994 0.851977 0.0205719C0.903895 0.00304433 0.958885 -0.00271032 1.01317 0.00370348C1.06906 -0.00428481 1.12599 0.000687291 1.17978 0.0182558C1.23356 0.0358243 1.28285 0.0655445 1.32403 0.105241L6.89618 5.69539C6.93441 5.73493 6.96338 5.78291 6.98089 5.83569C6.9984 5.88847 7.00398 5.94467 6.99721 6C7.00398 6.05533 6.9984 6.11153 6.98089 6.16431C6.96338 6.21709 6.93441 6.26507 6.89618 6.30461Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevron);
export default __webpack_public_path__ + "static/media/chevron.9fae2cf38599959c6ffdc4e85384eea4.svg";
export { ForwardRef as ReactComponent };